/* eslint-disable */
/**
 * GENERATED by scripts/generate-blog-tag-catalog.mjs — do not edit by hand.
 * Canonical blog tags with their posts (newest first), locales and indexability.
 */
export const BLOG_TAG_PAGES = [
  {
    "slug": "ai",
    "label": {
      "tr": "Yapay zeka (AI)",
      "en": "AI"
    },
    "aliases": [],
    "postSlugs": [
      "ux-design-in-ai-products",
      "evaluation-debt-in-ai-product-features",
      "ai-arch-2025"
    ],
    "postCount": 3,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2026-03-28"
  },
  {
    "slug": "ai-assistant",
    "label": {
      "tr": "AI asistanı",
      "en": "AI assistant"
    },
    "aliases": [],
    "postSlugs": [
      "chatgpt-integration-business-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-06-25"
  },
  {
    "slug": "ai-development-company",
    "label": {
      "tr": "Yapay zeka yazılım şirketi",
      "en": "AI development company"
    },
    "aliases": [
      "yapay-zeka-yazilim-sirketi"
    ],
    "postSlugs": [
      "ai-development-company-selection-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-07-03"
  },
  {
    "slug": "ai-product-development",
    "label": {
      "tr": "AI ürün geliştirme",
      "en": "AI product development"
    },
    "aliases": [],
    "postSlugs": [
      "ai-development-company-selection-guide",
      "ux-design-in-ai-products"
    ],
    "postCount": 2,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2026-07-03"
  },
  {
    "slug": "api-design",
    "label": {
      "tr": "API tasarımı",
      "en": "API design"
    },
    "aliases": [],
    "postSlugs": [
      "api-contract-evolution-without-breakage"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-03-12"
  },
  {
    "slug": "architecture",
    "label": {
      "tr": "Yazılım mimarisi",
      "en": "Software architecture"
    },
    "aliases": [],
    "postSlugs": [
      "developer-experience-as-architecture",
      "tech-debt-2025",
      "edge-comp-2025",
      "dist-sys-2025",
      "rn-jsi-2025"
    ],
    "postCount": 5,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2025-11-07"
  },
  {
    "slug": "backend",
    "label": {
      "tr": "Backend",
      "en": "Backend"
    },
    "aliases": [],
    "postSlugs": [
      "api-contract-evolution-without-breakage",
      "saas-mt-2025",
      "dist-sys-2025",
      "node-ev-2025"
    ],
    "postCount": 4,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2026-03-12"
  },
  {
    "slug": "canary",
    "label": {
      "tr": "Canary release",
      "en": "Canary releases"
    },
    "aliases": [],
    "postSlugs": [
      "release-geometry-progressive-risk-slicing"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-10-04"
  },
  {
    "slug": "chatgpt-integration",
    "label": {
      "tr": "ChatGPT entegrasyonu",
      "en": "ChatGPT integration"
    },
    "aliases": [
      "chatgpt-entegrasyonu"
    ],
    "postSlugs": [
      "chatgpt-integration-business-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-06-25"
  },
  {
    "slug": "cloud",
    "label": {
      "tr": "Bulut",
      "en": "Cloud"
    },
    "aliases": [],
    "postSlugs": [
      "srv-obs-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-04-05"
  },
  {
    "slug": "compatibility",
    "label": {
      "tr": "Geriye dönük uyumluluk",
      "en": "Backward compatibility"
    },
    "aliases": [],
    "postSlugs": [
      "api-contract-evolution-without-breakage"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-03-12"
  },
  {
    "slug": "conflict-resolution",
    "label": {
      "tr": "Çatışma çözümü",
      "en": "Conflict resolution"
    },
    "aliases": [],
    "postSlugs": [
      "offline-first-mobile-sync-conflict-discipline"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-09-19"
  },
  {
    "slug": "custom-software-development-company",
    "label": {
      "tr": "Özel yazılım geliştirme şirketi",
      "en": "Custom software development company"
    },
    "aliases": [],
    "postSlugs": [
      "custom-software-development-company-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-07-05"
  },
  {
    "slug": "delivery",
    "label": {
      "tr": "Yazılım teslimatı",
      "en": "Software delivery"
    },
    "aliases": [],
    "postSlugs": [
      "tech-debt-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-03-30"
  },
  {
    "slug": "deprecation",
    "label": {
      "tr": "Deprecation yönetimi",
      "en": "Deprecation"
    },
    "aliases": [],
    "postSlugs": [
      "api-contract-evolution-without-breakage"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-03-12"
  },
  {
    "slug": "developer-experience",
    "label": {
      "tr": "Geliştirici deneyimi",
      "en": "Developer experience"
    },
    "aliases": [],
    "postSlugs": [
      "developer-experience-as-architecture"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-11-07"
  },
  {
    "slug": "distributed-systems",
    "label": {
      "tr": "Dağıtık sistemler",
      "en": "Distributed systems"
    },
    "aliases": [],
    "postSlugs": [
      "edge-comp-2025",
      "dist-sys-2025"
    ],
    "postCount": 2,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2025-03-12"
  },
  {
    "slug": "drift",
    "label": {
      "tr": "Model drift",
      "en": "Model drift"
    },
    "aliases": [],
    "postSlugs": [
      "evaluation-debt-in-ai-product-features"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-02-01"
  },
  {
    "slug": "edge",
    "label": {
      "tr": "Edge computing",
      "en": "Edge computing"
    },
    "aliases": [],
    "postSlugs": [
      "edge-comp-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-03-12"
  },
  {
    "slug": "engineering",
    "label": {
      "tr": "Yazılım mühendisliği",
      "en": "Software engineering"
    },
    "aliases": [],
    "postSlugs": [
      "developer-experience-as-architecture",
      "release-geometry-progressive-risk-slicing"
    ],
    "postCount": 2,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2025-11-07"
  },
  {
    "slug": "evaluation",
    "label": {
      "tr": "AI değerlendirme (evaluation)",
      "en": "AI evaluation"
    },
    "aliases": [],
    "postSlugs": [
      "evaluation-debt-in-ai-product-features"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-02-01"
  },
  {
    "slug": "event-loop",
    "label": {
      "tr": "Event loop",
      "en": "Event loop"
    },
    "aliases": [],
    "postSlugs": [
      "node-ev-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-02-12"
  },
  {
    "slug": "frontend",
    "label": {
      "tr": "Frontend",
      "en": "Frontend"
    },
    "aliases": [],
    "postSlugs": [
      "consistency-budgets-streaming-interfaces",
      "react-conc-2025"
    ],
    "postCount": 2,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2026-01-09"
  },
  {
    "slug": "governance",
    "label": {
      "tr": "AI yönetişimi",
      "en": "AI governance"
    },
    "aliases": [],
    "postSlugs": [
      "ai-arch-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-03-18"
  },
  {
    "slug": "ios-android-gelistirme",
    "label": {
      "tr": "iOS ve Android geliştirme",
      "en": "iOS and Android development"
    },
    "aliases": [],
    "postSlugs": [
      "mobile-app-development-cost-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-06-28"
  },
  {
    "slug": "jsi",
    "label": {
      "tr": "JSI",
      "en": "JSI"
    },
    "aliases": [],
    "postSlugs": [
      "rn-jsi-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-02-05"
  },
  {
    "slug": "latency",
    "label": {
      "tr": "Gecikme (latency)",
      "en": "Latency"
    },
    "aliases": [],
    "postSlugs": [
      "edge-comp-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-03-12"
  },
  {
    "slug": "leadership",
    "label": {
      "tr": "Mühendislik liderliği",
      "en": "Engineering leadership"
    },
    "aliases": [],
    "postSlugs": [
      "tech-debt-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-03-30"
  },
  {
    "slug": "llm",
    "label": {
      "tr": "LLM",
      "en": "LLM"
    },
    "aliases": [],
    "postSlugs": [
      "evaluation-debt-in-ai-product-features",
      "ai-arch-2025"
    ],
    "postCount": 2,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2026-02-01"
  },
  {
    "slug": "llm-integration",
    "label": {
      "tr": "LLM entegrasyonu",
      "en": "LLM integration"
    },
    "aliases": [],
    "postSlugs": [
      "ai-development-company-selection-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-07-03"
  },
  {
    "slug": "mobil-uygulama-gelistirme",
    "label": {
      "tr": "Mobil uygulama geliştirme",
      "en": "Mobile app development"
    },
    "aliases": [],
    "postSlugs": [
      "mobile-app-development-cost-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-06-28"
  },
  {
    "slug": "mobile",
    "label": {
      "tr": "Mobil",
      "en": "Mobile"
    },
    "aliases": [],
    "postSlugs": [
      "offline-first-mobile-sync-conflict-discipline",
      "mob-perf-2025",
      "rn-jsi-2025"
    ],
    "postCount": 3,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2025-09-19"
  },
  {
    "slug": "mobile-app-development-company",
    "label": {
      "tr": "Mobil uygulama geliştirme şirketi",
      "en": "Mobile app development company"
    },
    "aliases": [],
    "postSlugs": [
      "mobile-app-development-cost-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-06-28"
  },
  {
    "slug": "mobile-app-development-cost",
    "label": {
      "tr": "Mobil uygulama maliyeti",
      "en": "Mobile app development cost"
    },
    "aliases": [],
    "postSlugs": [
      "mobile-app-development-cost-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-06-28"
  },
  {
    "slug": "multi-tenancy",
    "label": {
      "tr": "Çoklu kiracı (multi-tenancy)",
      "en": "Multi-tenancy"
    },
    "aliases": [],
    "postSlugs": [
      "saas-mt-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-03-05"
  },
  {
    "slug": "mvp",
    "label": {
      "tr": "MVP",
      "en": "MVP"
    },
    "aliases": [],
    "postSlugs": [
      "mvp-development-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-03-08"
  },
  {
    "slug": "mvp-development-company",
    "label": {
      "tr": "MVP geliştirme şirketi",
      "en": "MVP development company"
    },
    "aliases": [],
    "postSlugs": [
      "mvp-development-company-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-06-20"
  },
  {
    "slug": "mvp-gelistirme",
    "label": {
      "tr": "MVP geliştirme",
      "en": "MVP development"
    },
    "aliases": [],
    "postSlugs": [
      "mvp-development-company-guide",
      "mvp-development-guide"
    ],
    "postCount": 2,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2026-06-20"
  },
  {
    "slug": "mvp-maliyeti",
    "label": {
      "tr": "MVP maliyeti",
      "en": "MVP cost"
    },
    "aliases": [],
    "postSlugs": [
      "mvp-development-company-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-06-20"
  },
  {
    "slug": "nodejs",
    "label": {
      "tr": "Node.js",
      "en": "Node.js"
    },
    "aliases": [],
    "postSlugs": [
      "node-ev-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-02-12"
  },
  {
    "slug": "observability",
    "label": {
      "tr": "Gözlemlenebilirlik",
      "en": "Observability"
    },
    "aliases": [],
    "postSlugs": [
      "srv-obs-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-04-05"
  },
  {
    "slug": "offline-first",
    "label": {
      "tr": "Offline-first",
      "en": "Offline-first"
    },
    "aliases": [],
    "postSlugs": [
      "offline-first-mobile-sync-conflict-discipline"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-09-19"
  },
  {
    "slug": "openai-integration-services",
    "label": {
      "tr": "OpenAI entegrasyon hizmetleri",
      "en": "OpenAI integration services"
    },
    "aliases": [],
    "postSlugs": [
      "chatgpt-integration-business-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-06-25"
  },
  {
    "slug": "ownership",
    "label": {
      "tr": "Kod sahipliği (ownership)",
      "en": "Code ownership"
    },
    "aliases": [],
    "postSlugs": [
      "developer-experience-as-architecture"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-11-07"
  },
  {
    "slug": "ozel-yazilim-gelistirme",
    "label": {
      "tr": "Özel yazılım geliştirme",
      "en": "Custom software development"
    },
    "aliases": [],
    "postSlugs": [
      "custom-software-development-company-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-07-05"
  },
  {
    "slug": "performance",
    "label": {
      "tr": "Performans",
      "en": "Performance"
    },
    "aliases": [],
    "postSlugs": [
      "mob-perf-2025",
      "react-conc-2025",
      "node-ev-2025"
    ],
    "postCount": 3,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2025-03-24"
  },
  {
    "slug": "product-quality",
    "label": {
      "tr": "Ürün kalitesi",
      "en": "Product quality"
    },
    "aliases": [],
    "postSlugs": [
      "evaluation-debt-in-ai-product-features"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-02-01"
  },
  {
    "slug": "progressive-delivery",
    "label": {
      "tr": "Progressive delivery",
      "en": "Progressive delivery"
    },
    "aliases": [],
    "postSlugs": [
      "release-geometry-progressive-risk-slicing"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-10-04"
  },
  {
    "slug": "react",
    "label": {
      "tr": "React",
      "en": "React"
    },
    "aliases": [],
    "postSlugs": [
      "consistency-budgets-streaming-interfaces",
      "react-conc-2025"
    ],
    "postCount": 2,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2026-01-09"
  },
  {
    "slug": "react-native",
    "label": {
      "tr": "React Native",
      "en": "React Native"
    },
    "aliases": [],
    "postSlugs": [
      "offline-first-mobile-sync-conflict-discipline",
      "mob-perf-2025",
      "rn-jsi-2025"
    ],
    "postCount": 3,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2025-09-19"
  },
  {
    "slug": "release",
    "label": {
      "tr": "Release yönetimi",
      "en": "Release management"
    },
    "aliases": [],
    "postSlugs": [
      "release-geometry-progressive-risk-slicing"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-10-04"
  },
  {
    "slug": "reliability",
    "label": {
      "tr": "Güvenilirlik",
      "en": "Reliability"
    },
    "aliases": [],
    "postSlugs": [
      "dist-sys-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-02-28"
  },
  {
    "slug": "rollback",
    "label": {
      "tr": "Rollback",
      "en": "Rollback"
    },
    "aliases": [],
    "postSlugs": [
      "release-geometry-progressive-risk-slicing"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-10-04"
  },
  {
    "slug": "saas",
    "label": {
      "tr": "SaaS",
      "en": "SaaS"
    },
    "aliases": [],
    "postSlugs": [
      "saas-scaling-strategies",
      "saas-mt-2025"
    ],
    "postCount": 2,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2026-03-22"
  },
  {
    "slug": "saas-development-company",
    "label": {
      "tr": "SaaS geliştirme şirketi",
      "en": "SaaS development company"
    },
    "aliases": [],
    "postSlugs": [
      "saas-development-cost-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-07-01"
  },
  {
    "slug": "saas-development-cost",
    "label": {
      "tr": "SaaS geliştirme maliyeti",
      "en": "SaaS development cost"
    },
    "aliases": [],
    "postSlugs": [
      "saas-development-cost-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-07-01"
  },
  {
    "slug": "saas-gelistirme",
    "label": {
      "tr": "SaaS geliştirme",
      "en": "SaaS development"
    },
    "aliases": [],
    "postSlugs": [
      "saas-development-cost-guide",
      "saas-scaling-strategies"
    ],
    "postCount": 2,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2026-07-01"
  },
  {
    "slug": "saas-mvp",
    "label": {
      "tr": "SaaS MVP",
      "en": "SaaS MVP"
    },
    "aliases": [],
    "postSlugs": [
      "saas-development-cost-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-07-01"
  },
  {
    "slug": "schema-evolution",
    "label": {
      "tr": "Şema evrimi",
      "en": "Schema evolution"
    },
    "aliases": [],
    "postSlugs": [
      "api-contract-evolution-without-breakage"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-03-12"
  },
  {
    "slug": "security",
    "label": {
      "tr": "Güvenlik",
      "en": "Security"
    },
    "aliases": [],
    "postSlugs": [
      "saas-mt-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-03-05"
  },
  {
    "slug": "serverless",
    "label": {
      "tr": "Serverless",
      "en": "Serverless"
    },
    "aliases": [],
    "postSlugs": [
      "srv-obs-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-04-05"
  },
  {
    "slug": "software-development-partner",
    "label": {
      "tr": "Yazılım geliştirme partneri",
      "en": "Software development partner"
    },
    "aliases": [],
    "postSlugs": [
      "custom-software-development-company-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-07-05"
  },
  {
    "slug": "sre",
    "label": {
      "tr": "SRE",
      "en": "SRE"
    },
    "aliases": [],
    "postSlugs": [
      "srv-obs-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-04-05"
  },
  {
    "slug": "startup-product-engineering",
    "label": {
      "tr": "Startup ürün mühendisliği",
      "en": "Startup product engineering"
    },
    "aliases": [],
    "postSlugs": [
      "mvp-development-company-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-06-20"
  },
  {
    "slug": "state-architecture",
    "label": {
      "tr": "State mimarisi",
      "en": "State architecture"
    },
    "aliases": [],
    "postSlugs": [
      "consistency-budgets-streaming-interfaces"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-01-09"
  },
  {
    "slug": "streaming-ui",
    "label": {
      "tr": "Streaming arayüzler",
      "en": "Streaming UI"
    },
    "aliases": [],
    "postSlugs": [
      "consistency-budgets-streaming-interfaces"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-01-09"
  },
  {
    "slug": "suspense",
    "label": {
      "tr": "React Suspense",
      "en": "React Suspense"
    },
    "aliases": [],
    "postSlugs": [
      "consistency-budgets-streaming-interfaces"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-01-09"
  },
  {
    "slug": "sync",
    "label": {
      "tr": "Veri senkronizasyonu",
      "en": "Data sync"
    },
    "aliases": [],
    "postSlugs": [
      "offline-first-mobile-sync-conflict-discipline"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-09-19"
  },
  {
    "slug": "system-design",
    "label": {
      "tr": "Sistem tasarımı",
      "en": "System design"
    },
    "aliases": [],
    "postSlugs": [
      "ai-arch-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-03-18"
  },
  {
    "slug": "tech-debt",
    "label": {
      "tr": "Teknik borç",
      "en": "Tech debt"
    },
    "aliases": [],
    "postSlugs": [
      "tech-debt-2025"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-03-30"
  },
  {
    "slug": "testing",
    "label": {
      "tr": "Test stratejisi",
      "en": "Testing"
    },
    "aliases": [],
    "postSlugs": [
      "developer-experience-as-architecture"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2025-11-07"
  },
  {
    "slug": "ux",
    "label": {
      "tr": "UX tasarımı",
      "en": "UX design"
    },
    "aliases": [
      "ux-design"
    ],
    "postSlugs": [
      "ux-design-in-ai-products",
      "mob-perf-2025",
      "react-conc-2025"
    ],
    "postCount": 3,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": true,
    "lastmod": "2026-03-28"
  },
  {
    "slug": "yazilim-sirketi",
    "label": {
      "tr": "Yazılım şirketi",
      "en": "Software company"
    },
    "aliases": [],
    "postSlugs": [
      "custom-software-development-company-guide"
    ],
    "postCount": 1,
    "locales": [
      "tr",
      "en"
    ],
    "indexable": false,
    "lastmod": "2026-07-05"
  }
];

/** Published blog posts with at least one locale (static catalogs + Supabase), tagged or not. */
export const BLOG_PUBLISHED_POST_COUNT = 28;
